(() => {
  const update = (viewport, bar, track) => {
    const max = viewport.scrollWidth - viewport.clientWidth;
    if (track) track.style.display = max > 0 ? '' : 'none';
    const ratio = max > 0 ? viewport.scrollLeft / max : 0;
    const minWidth = 10;
    bar.style.width = `${minWidth + ratio * (100 - minWidth)}%`;
  };

  const TAB_TARGETS = {
    1: '.cc-promo-brand-sale',
    2: '.cc-promo-free-gift',
    3: '.cc-promo-brand-bonuses',
    5: '.cc-collection-sales',
    4: '.promo-clearance',
  };

  const cssVar = (name) => {
    const value = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
    return Number.isNaN(value) ? 0 : value;
  };

  const hasStickyHeaderOffset = () => {
    if (window.theme && window.theme.mediaMatches) return Boolean(window.theme.mediaMatches.md);
    return window.matchMedia('(min-width: 769px)').matches;
  };

  const headerEnd = () => {
    if (!hasStickyHeaderOffset()) return Math.max(0, cssVar('--header-height') || 115);
    return Math.max(0, cssVar('--header-end') || cssVar('--header-height'));
  };

  const scrollToTarget = (target, nav) => {
    const desired = () => {
      const navH = nav ? nav.getBoundingClientRect().height : 0;
      return target.getBoundingClientRect().top + window.pageYOffset - headerEnd() - navH;
    };
    window.scrollTo({ top: desired(), behavior: 'smooth' });

    // The sticky header collapses while scrolling down, so --header-end shrinks
    // mid-flight. Re-align once the scroll settles to land flush under the nav.
    if ('onscrollend' in window) {
      let corrections = 0;
      const onEnd = () => {
        if (corrections >= 3 || Math.abs(desired() - window.pageYOffset) <= 2) {
          window.removeEventListener('scrollend', onEnd);
          return;
        }
        corrections += 1;
        window.scrollTo({ top: desired(), behavior: 'smooth' });
      };
      window.addEventListener('scrollend', onEnd);
    } else {
      setTimeout(() => {
        if (Math.abs(desired() - window.pageYOffset) > 2) {
          window.scrollTo({ top: desired(), behavior: 'smooth' });
        }
      }, 420);
    }
  };

  const initFixedNav = (nav) => {
    if (!nav) return;
    const spacer = document.createElement('div');
    spacer.className = 'pbs-nav__spacer';
    spacer.setAttribute('aria-hidden', 'true');
    nav.parentNode.insertBefore(spacer, nav);

    const onScroll = () => {
      const navTop = headerEnd();
      nav.style.top = `${navTop}px`;
      const threshold = spacer.getBoundingClientRect().top - navTop;
      if (!nav.classList.contains('is-fixed') && threshold <= 0) {
        spacer.style.height = `${nav.getBoundingClientRect().height}px`;
        nav.classList.add('is-fixed');
      } else if (nav.classList.contains('is-fixed') && threshold > 0) {
        nav.classList.remove('is-fixed');
        spacer.style.height = '0px';
        nav.style.top = '';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  };

  const setActive = (section, tabKey) => {
    section.querySelectorAll('[data-pbs-tab]').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.pbsTab === String(tabKey));
    });
    const active = section.querySelector(`.pbs-nav__menu [data-pbs-tab="${tabKey}"]`);
    const current = section.querySelector('.pbs-nav__current span');
    if (active && current) current.textContent = active.textContent.trim();
  };

  const initScrollSpy = (section, nav) => {
    const spied = Object.keys(TAB_TARGETS)
      .map((tab) => ({ tab, el: document.querySelector(TAB_TARGETS[tab]) }))
      .filter((entry) => entry.el)
      .sort((a, b) => a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top);
    if (spied.length < 2) return;

    const navH = nav ? nav.getBoundingClientRect().height : 0;
    const onScroll = () => {
      const line = headerEnd() + navH + 100;
      let current = spied[0].tab;
      for (const entry of spied) {
        if (entry.el.getBoundingClientRect().top - line <= 0) current = entry.tab;
        else break;
      }
      setActive(section, current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  };

  const initNav = (section) => {
    const nav = section.querySelector('.pbs-nav');
    initFixedNav(nav);
    section.querySelectorAll('[data-pbs-tab]').forEach((tab) => {
      const target = document.querySelector(TAB_TARGETS[tab.dataset.pbsTab] || '');
      if (!target) return;
      tab.addEventListener('click', (evt) => {
        evt.preventDefault();
        const details = tab.closest('details');
        if (details) details.open = false;
        setActive(section, tab.dataset.pbsTab);
        scrollToTarget(target, nav);
      });
    });
    initScrollSpy(section, nav);
  };

  const init = (section) => {
    initNav(section);
    const viewport = section.querySelector('.pbs-carousel__viewport');
    const bar = section.querySelector('.pbs-carousel__progress-bar');
    const track = section.querySelector('.pbs-carousel__progress');
    if (!viewport || !bar) return;
    const handler = () => update(viewport, bar, track);
    viewport.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler);
    handler();
  };

  const initAll = (root) => root.querySelectorAll('.promo-brand-sale').forEach(init);

  initAll(document);
  document.addEventListener('shopify:section:load', (evt) => initAll(evt.target));
})();
